import { render, staticRenderFns } from "./CustomsInfoModule.vue?vue&type=template&id=7b079796"
import script from "./CustomsInfoModule.vue?vue&type=script&lang=js"
export * from "./CustomsInfoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports